/**
 * The signaling strategies that exist, in the order they are tried.
 *
 * One import and one entry each, and nothing else. This stays the list of what exists rather than a
 * second place to tune anything: budgets live with the runner, relay lists live with the strategy.
 *
 * Order is preference order. The first entry that answers a probe and settles a room wins, and the
 * rest are never opened.
 */

import { BITTORRENT_SIGNALING } from '@/net/signaling/strategies/bittorrent';
import { NOSTR_SIGNALING } from '@/net/signaling/strategies/nostr';
import type { SignalingStrategy } from '@/net/signaling/signalingContract';

export const SIGNALING_STRATEGIES: readonly SignalingStrategy[] = [
  NOSTR_SIGNALING,
  BITTORRENT_SIGNALING,
];
